// Closing or replacing a provider's popup is the user's choice, not an error
const CANCELLED = [
  'auth/cancelled-popup-request',
  'auth/popup-closed-by-user',
  'auth/user-cancelled',
];

// Each sign-in error the user can act on, with the message that says how
const MESSAGES = {
  'auth/email-already-in-use': 'auth_error_email_in_use',
  'auth/invalid-credential': 'auth_error_wrong_password',
  'auth/invalid-email': 'email_login_form_toast_error_enter_valid_email',
  'auth/missing-password': 'email_login_form_toast_error_enter_password',
  'auth/network-request-failed': 'auth_error_network',
  'auth/popup-blocked': 'auth_error_popup_blocked',
  'auth/too-many-requests': 'auth_error_too_many_requests',
  'auth/user-disabled': 'email_login_form_toast_error_account_disabled',
  'auth/user-not-found': 'auth_error_user_not_found',
  'auth/weak-password': 'email_login_form_toast_error_weak_password',
  'auth/wrong-password': 'auth_error_wrong_password',
};

// Errors that mean a wrong password, which no one typed in a provider's popup
const PASSWORD_ONLY = ['auth/invalid-credential', 'auth/wrong-password'];

/**
 * The message to show for a Firebase sign-in, sign-up or password-reset error.
 * Never Firebase's own text: an error with no specific message gets the
 * generic one.
 * @param {Function} t the translate function
 * @param {Error} error what Firebase threw
 * @param {object} [options]
 * @param {boolean} [options.social] a Google, Apple or Facebook sign-in, where
 *   a password message would make no sense
 * @returns {string|null} the message, or null when nothing should be shown
 *   (the user closed the provider's popup)
 */
export function authErrorMessage(t, error, { social = false } = {}) {
  const code = error?.code;
  if (CANCELLED.includes(code)) return null;
  if (social && PASSWORD_ONLY.includes(code)) return t('auth_error_generic');
  return t(MESSAGES[code] || 'auth_error_generic');
}

export default authErrorMessage;
